// extracted by mini-css-extract-plugin
export var danger = "_33-6";
export var lightPink = "_33-a";
export var medium = "_33-j";
export var nearSquare = "_33-m";
export var neutralBlue = "_33-8";
export var neutralYellow = "_33-7";
export var noCapitalize = "_33-1";
export var normal = "_33-2";
export var pill = "_33-0";
export var primary = "_33-3";
export var primaryLight = "_33-4";
export var shadow = "_33-n";
export var small = "_33-k";
export var solidBlack = "_33-i";
export var solidGreen = "_33-d";
export var solidLightBlue = "_33-f";
export var solidNavy = "_33-e";
export var solidOrange = "_33-h";
export var solidPink = "_33-g";
export var solidRed = "_33-b";
export var solidWhite = "_33-9";
export var solidYellow = "_33-c";
export var success = "_33-5";
export var xsmall = "_33-l";